import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Input — DESIGN.md
 *
 * Standardized text input with primary-tinted focus ring and danger state.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  function Input({ className, type, ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'h-10 w-full min-w-0 rounded-lg border border-border-strong bg-surface px-3 py-2 text-sm text-text outline-none transition-colors',
          'placeholder:text-text-subtle',
          'focus:border-primary focus:ring-2 focus:ring-primary/20',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-surface-muted disabled:opacity-60',
          'aria-invalid:border-danger aria-invalid:ring-2 aria-invalid:ring-danger/20',
          'dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100',
          className,
        )}
        {...props}
      />
    )
  },
)

export { Input }
